import { getkwargs } from "../../utilities/functions";
import { onChange } from "../onchange";

export const onChangeSelectCRM = ({
  partner_id = false,
  tag_id = [],
  context,
  company_id,
  model = "crm.lead",
}) => {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [
        [],
        {
          show_enrich_button: false,
          stage_id: 1,
          ribbon_message: false,
          active: true,
          meeting_count: 0,
          quotation_count: 0,
          sale_amount_total: 0,
          sale_order_count: 0,
          visitor_page_count: 0,
          name: false,
          company_currency: 2,
          expected_revenue: 0,
          automated_probability: 7.87,
          is_automated_probability: true,
          probability: 7.87,
          partner_id: partner_id ? Number(partner_id) : false,
          partner_name: false,
          street: false,
          street2: false,
          city: false,
          state_id: false,
          zip: false,
          country_id: false,
          website: false,
          lang_id: false,
          is_blacklisted: false,
          partner_is_blacklisted: false,
          phone_blacklisted: false,
          mobile_blacklisted: false,
          email_state: false,
          phone_state: false,
          email_from: false,
          otp_to_be_verified: false,
          email_verified: false,
          otp: false,
          phone: false,
          contact_name: false,
          title: false,
          email_cc: false,
          function: false,
          mobile: false,
          date_deadline: false,
          priority: "0",
          tag_ids: [[6, false, tag_id]],
          user_id: context.uid,
          team_id: 1,
          type: "opportunity",
          lost_reason: false,
          date_conversion: false,
          company_id: company_id,
          description: false,
          message_bounce: 0,
          campaign_id: false,
          medium_id: false,
          source_id: false,
          referred: false,
          date_open: "2024-04-02 10:29:25",
          date_closed: false,
          day_open: 0,
          day_close: 0,
          message_follower_ids: [],
          activity_ids: [],
          message_ids: [],
        },
        "partner_id",
        {
          show_enrich_button: "",
          stage_id: "1",
          ribbon_message: "",
          active: "",
          meeting_count: "",
          quotation_count: "",
          sale_amount_total: "",
          sale_order_count: "",
          visitor_page_count: "",
          name: "",
          company_currency: "",
          expected_revenue: "",
          automated_probability: "1",
          is_automated_probability: "",
          probability: "1",
          partner_id: "1",
          partner_name: "",
          street: "",
          street2: "",
          city: "",
          state_id: "1",
          zip: "1",
          country_id: "1",
          website: "",
          lang_id: "",
          is_blacklisted: "",
          partner_is_blacklisted: "",
          phone_blacklisted: "",
          mobile_blacklisted: "",
          email_state: "1",
          phone_state: "1",
          email_from: "1",
          otp_to_be_verified: "",
          email_verified: "",
          otp: "",
          phone: "1",
          contact_name: "",
          title: "",
          email_cc: "",
          function: "",
          mobile: "1",
          date_deadline: "",
          priority: "",
          tag_ids: "1",
          user_id: context.uid,
          team_id: "1",
          type: "1",
          lost_reason: "",
          date_conversion: "",
          company_id: company_id,
          description: "",
          message_bounce: "",
          campaign_id: "",
          medium_id: "",
          source_id: "1",
          referred: "",
          date_open: "1",
          date_closed: "1",
          day_open: "",
          day_close: "",
          message_follower_ids: "",
          "message_follower_ids.res_model": "",
          "message_follower_ids.res_id": "",
          "message_follower_ids.partner_id": "",
          "message_follower_ids.channel_id": "",
          activity_ids: "",
          "activity_ids.res_name": "",
          "activity_ids.activity_type_id": "1",
          "activity_ids.summary": "",
          "activity_ids.date_deadline": "",
          message_ids: "",
          "message_ids.date": "",
          "message_ids.subject": "",
          "message_ids.author_id": "",
          "message_ids.model": "",
          "message_ids.res_id": "",
        },
      ],
      model,
      method: "onchange",
      ...getkwargs({ company_id, context, model, view_type: "form" }),
    },
  });

  return onChange(raw, model);
};
